import * as actionTypes from './actionTypes';


export const setLoginStatus = () => {
  return {
    type: actionTypes.SET_LOGIN_STATUS
  }
}

export const setLoginModal = () => {
  return {
    type: actionTypes.SET_LOGIN_MODAL
  }
}

